import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import React from "react";

interface PrintShippingDisabledTipProps {
    order: OrderDTO;
}

const printShippingDisabledOrderTags: OrderTag[] = [
    OrderTag.ALI_AE_DOOR_PICKUP,
    OrderTag.ALI_AE_SELF_SEND,
    OrderTag.JD_HYPERLINK_ORDER,
    OrderTag.JD_HYPERLINK_SUBSIDY_ORDER,
];

export function shouldRenderPrintShippingDisabledTip(order: OrderDTO) {
    return !!order.tags?.some((tag) => printShippingDisabledOrderTags.includes(tag));
}

const PrintShippingDisabledTip: React.FC<PrintShippingDisabledTipProps> = function (props) {
    const { order } = props;

    if (!shouldRenderPrintShippingDisabledTip(order)) {
        return null;
    }

    const disabledReasons = [];

    const style = { color: "#f5222d" };

    for (const tag of order.tags || []) {
        if ([OrderTag.ALI_AE_DOOR_PICKUP, OrderTag.ALI_AE_SELF_SEND].includes(tag)) {
            disabledReasons.push(
                <div key={tag}>
                    <span style={style}>
                        速卖通订单需要在发货前及时打印和合理张贴揽收单、箱唛和货品标签，建议前往商家后台进行操作
                        <a
                            className="ml3"
                            target="_blank"
                            href="https://work.1688.com/?spm=a2638g.u_5c057.0.du_51fff.4ecf1768Byrtxg&_path_=sellerPro/cross_boarder_2/ae_order"
                        >
                            去后台
                        </a>
                    </span>
                </div>,
            );
        }

        if ([OrderTag.JD_HYPERLINK_ORDER, OrderTag.JD_HYPERLINK_SUBSIDY_ORDER].includes(tag)) {
            disabledReasons.push(
                <div key={tag}>
                    <span style={style}>
                        该订单不支持在发货易内发货，请在发货易内添加供销店铺后进行发货
                        <a
                            className="ml3"
                            target="_blank"
                            href={
                                tag === OrderTag.JD_HYPERLINK_ORDER
                                    ? "https://qw15p3s8hv.feishu.cn/wiki/UG4Awq8Xli9umAkNkN4cL5IFn3c#DkeTdKifeoOGikxUqUzcSdEbnKh"
                                    : "https://qw15p3s8hv.feishu.cn/wiki/UG4Awq8Xli9umAkNkN4cL5IFn3c#XMv8d8IDZoeW63xWkUAcVU9snCb"
                            }
                        >
                            查看教程
                        </a>
                    </span>
                </div>,
            );
        }
    }

    if (!disabledReasons.length) return null;

    return <>{disabledReasons}</>;
};

export default React.memo(PrintShippingDisabledTip);
